// extracted by mini-css-extract-plugin
export var folderContainer = "folder-module--folderContainer--ncW9U";
export var docs0 = "folder-module--docs0--GJIbP";
export var docs1 = "folder-module--docs1--Tlvyg";